export class AreaParticipacaoModel {

    public id: number;
    public nome: string;
    public dataAtualizacao: string;
}



// WEBPACK FOOTER //
// ./src/app/shared/model/area-participacao.model.ts